import useAccount from '@/compositions/accounting/useAccount';
import useVacancies from '@/compositions/useVacancies';
import { computed, onMounted, ref } from '@vue/composition-api';
import { useI18n } from 'vue-i18n-composable';
import DialogLimitedVacancies from '@/components/DialogLimitedVacancies.vue';

export default {
  components: { DialogLimitedVacancies },
  setup() {
    const { account, fetchIfNull } = useAccount();
    const { notArchivedVacancies } = useVacancies();
    const { tc } = useI18n();
    const dialogMaximumVacancies = ref(false);
    const maxVacanciesTitle = ref('');
    const planTitle = computed(() => account.value?.plan.title);
    const maximumVacancies = computed(() => account.value?.maximumVacancies);
    const trialMaximumVacancies = computed(() => account.value?.trialMaximumVacancies);

    const notArchivedVacanciesLength = computed(() => notArchivedVacancies.value?.length);
    const limitedVacancies = computed(() => {
      if (trialMaximumVacancies.value && account.value.trialEnabled && (trialMaximumVacancies.value <= notArchivedVacanciesLength.value)) {
        return trialMaximumVacancies.value;
      }

      if (maximumVacancies.value && (maximumVacancies.value <= notArchivedVacanciesLength.value)) {
        return maximumVacancies.value;
      }
    });

    function openDialogMaximumVacancies(action) {
      switch (action) {
        case 'restore': {
          maxVacanciesTitle.value = tc('maxVacanciesRestoreTitle', limitedVacancies.value, { count: limitedVacancies.value });
          break;
        }
        case 'clone': {
          maxVacanciesTitle.value = tc('maxVacanciesCopyTitle', limitedVacancies.value, { count: limitedVacancies.value });
          break;
        }
        default: {
          break;
        }
      }
      dialogMaximumVacancies.value = true;
    }
    function cancelDialogMaximumVacancies() {
      dialogMaximumVacancies.value = false;
    }

    onMounted(async () => {
      await fetchIfNull();
    });

    return {
      dialogMaximumVacancies,
      cancelDialogMaximumVacancies,
      openDialogMaximumVacancies,
      limitedVacancies,
      maxVacanciesTitle,
      planTitle,
    };
  },
};
